import React, { createContext } from 'react';

interface AppContextItems {
  userRole: string;
  systemId: string;
}

export const AppContext = createContext<AppContextItems | null>(null);

type Props = { children: React.ReactNode };

// Clear stale hierarchy values from localStorage synchronously.
// The Apollo client reads these to scope auth headers (see apolloClient.ts).
// The hierarchy feature has been removed, so these must always be empty.
localStorage.removeItem('user_role');
localStorage.removeItem('system_id');

const StateProvider = ({ children }: Props): React.ReactElement => {
  const appContextItems: AppContextItems = {
    userRole: '',
    systemId: '',
  };

  return <AppContext.Provider value={appContextItems}>{children}</AppContext.Provider>;
};

export default StateProvider;
